import { FC, useState } from "react";
import { FormikHelpers } from "formik";
import {
  Form,
  Button,
  Modal,
  MessageField,
  FormButtons,
  useFileParser,
} from "@epcnetwork/core-ui-kit";

import { FormField } from "components";
import { DiffCommonFileItem, DiffAndCommonValues } from "../diff-common.types";
import { validationSchema } from "../diff-common.constants";

type DiffCommonModalFormProps = {
  file: DiffCommonFileItem;
  setClose: VoidFunction;
  onSubmitClick: (fileValues: DiffCommonFileItem) => void;
};

export const DiffCommonFormModal: FC<DiffCommonModalFormProps> = ({
  file,
  setClose,
  onSubmitClick,
}) => {
  const { loading, parsedFile, error } = useFileParser(file.originalFile);

  const [initialValues] = useState<DiffAndCommonValues>({ headerValues: file.data });

  const onSubmit = (
    values: DiffAndCommonValues,
    { setSubmitting }: FormikHelpers<DiffAndCommonValues>,
  ) => {
    onSubmitClick({
      ...file,
      isTuned: true,
      data: { ...file.data, ...values.headerValues },
    });
    setSubmitting(false);
  };

  return (
    <Modal isOpen={!!file} setClose={setClose}>
      <h2>Set values {file.originalFile.name}</h2>
      <MessageField message={error} />
      <Form
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        loading={loading}
        validationSchema={validationSchema}
      >
        <FormField
          type="file-table"
          name="headerValues"
          label="Select Email column"
          parsedFile={parsedFile}
          loading={loading}
        />
        <FormButtons>
          <Button appearance="secondary" onClick={setClose}>
            Cancel
          </Button>
          <Button type="submit">Set values</Button>
        </FormButtons>
      </Form>
    </Modal>
  );
};
